import {PIXI} from '@colonist/pixi'
import {UIGameAnimation} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {UIGameAchievementConfetti} from '../ui_game_achievement/UIGameAchievementConfetti'

export class ConfettiAnimationWrapper implements UIGameAnimation {
    private readonly confetti: UIGameAchievementConfetti

    constructor(uiGameManager: UIGameManager, parent: PIXI.Container, positionX: number, positionY: number, duration: number) {
        uiGameManager.eventController.registerUIGameAnimation(this)
        this.confetti = parent.addChild(new UIGameAchievementConfetti())

        this.confetti.launch({
            x: positionX,
            y: positionY,
            speed: [1.5, 6],
            angle: [0, Math.PI * 2],
            slow: 0.000005,
            gravity: [0.05, 0.1],
            count: 150,
        })

        setTimeout(() => {
            uiGameManager.eventController.unregisterUIGameAnimation(this)
            this.confetti.destroy()
        }, duration)
    }

    onGameTick(deltaTime: number, elapsedMS: number) {
        this.confetti.update(deltaTime, elapsedMS)
    }
}
